// extracted by mini-css-extract-plugin
export default {"userLink":"UserLink_userLink__h3PfJ"};